/* ============================================================================
   Sol Suave — V2.6 runtime: scroll reveal, stat counters, 10% email popup
   ========================================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------ scroll reveal */
  function initReveal() {
    var nodes = document.querySelectorAll('.ss-reveal:not(.is-in)');
    if (!nodes.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var el = e.target;
          var delay = parseInt(el.getAttribute('data-reveal-delay') || '0', 10);
          setTimeout(function () { el.classList.add('is-in'); }, delay);
          io.unobserve(el);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
    nodes.forEach(function (n) { io.observe(n); });
  }

  /* ------------------------------------------------------ stat counters */
  function formatNum(n) {
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function runCounter(el) {
    var target = parseFloat(el.getAttribute('data-count') || '0');
    if (!target || reduceMotion) {
      el.textContent = formatNum(target);
      return;
    }
    var dur = 1500;
    var start = null;
    function tick(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = formatNum(Math.round(target * eased));
      if (p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function initCounters() {
    var nodes = document.querySelectorAll('[data-count]:not([data-counted])');
    if (!nodes.length) return;
    nodes.forEach(function (n) { n.setAttribute('data-counted', '1'); });
    if (!('IntersectionObserver' in window)) {
      nodes.forEach(runCounter);
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          runCounter(e.target);
          io.unobserve(e.target);
        });
      },
      { threshold: 0.4 }
    );
    nodes.forEach(function (n) { io.observe(n); });
  }

  /* --------------------------------------------------------- 10% popup */
  var STORE_KEY = 'ss_pop_v1';

  function readState() {
    try {
      return JSON.parse(localStorage.getItem(STORE_KEY) || '{}');
    } catch (e) {
      return {};
    }
  }

  function writeState(patch) {
    try {
      var next = Object.assign(readState(), patch, { ts: Date.now() });
      localStorage.setItem(STORE_KEY, JSON.stringify(next));
    } catch (e) {
      /* private mode — the popup simply re-appears next visit */
    }
  }

  function initPopup() {
    var pop = document.getElementById('ss-pop');
    if (!pop || pop.dataset.ssBound) return;
    pop.dataset.ssBound = '1';

    var tab = document.getElementById('ss-poptab');
    var box = pop.querySelector('.ss-pop__box');
    var form = pop.querySelector('form');
    var stepForm = pop.querySelector('[data-pop-step="form"]');
    var stepDone = pop.querySelector('[data-pop-step="done"]');
    var errBox = pop.querySelector('.ss-pop__errors');
    var delay = parseInt(pop.getAttribute('data-delay') || '7', 10) * 1000;
    var again = parseInt(pop.getAttribute('data-again-days') || '14', 10);
    var lastFocus = null;
    var opened = false;
    var ajaxOff = false;

    function eligible() {
      var s = readState();
      if (s.status === 'subscribed') return false;
      if (s.status === 'dismissed' && s.ts && Date.now() - s.ts < again * 864e5) return false;
      return true;
    }

    function open(force) {
      if (opened) return;
      if (!force && !eligible()) return;
      opened = true;
      lastFocus = document.activeElement;
      pop.classList.add('is-open');
      pop.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (tab) tab.classList.remove('is-visible');
      var firstField = pop.querySelector('input[type="email"]');
      if (firstField && window.innerWidth > 749) setTimeout(function () { firstField.focus(); }, 420);
    }

    function close(markDismissed) {
      opened = false;
      pop.classList.remove('is-open');
      pop.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (markDismissed && readState().status !== 'subscribed') writeState({ status: 'dismissed' });
      if (tab && readState().status !== 'subscribed') tab.classList.add('is-visible');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function showDone() {
      if (stepForm) stepForm.hidden = true;
      if (stepDone) stepDone.hidden = false;
      writeState({ status: 'subscribed' });
      if (tab) tab.classList.remove('is-visible');
    }

    /* if the ajax answer is ambiguous, let the browser post the form the
       classic way — Shopify then returns ?customer_posted=true#ss-pop-form
       and the block below re-opens the popup already showing the code. */
    function classicSubmit() {
      ajaxOff = true;
      if (form.requestSubmit) form.requestSubmit();
      else form.submit();
    }

    pop.querySelectorAll('[data-pop-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { close(true); });
    });
    pop.addEventListener('click', function (e) {
      if (box && !box.contains(e.target)) close(true);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && pop.classList.contains('is-open')) close(true);
    });
    if (tab) tab.addEventListener('click', function () { open(true); });

    var copyBtn = pop.querySelector('.ss-pop__copy');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var code = copyBtn.getAttribute('data-code') || '';
        var done = function () {
          var old = copyBtn.getAttribute('data-label') || copyBtn.textContent;
          copyBtn.setAttribute('data-label', old);
          copyBtn.textContent = copyBtn.getAttribute('data-copied') || 'OK';
          setTimeout(function () { copyBtn.textContent = old; }, 2200);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done).catch(done);
        } else {
          var tmp = document.createElement('textarea');
          tmp.value = code;
          document.body.appendChild(tmp);
          tmp.select();
          try { document.execCommand('copy'); } catch (e) {}
          document.body.removeChild(tmp);
          done();
        }
      });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        if (ajaxOff || !window.fetch) return; /* let the browser post it */
        e.preventDefault();
        var btn = form.querySelector('button[type="submit"]');
        if (errBox) errBox.textContent = '';
        if (btn) {
          btn.disabled = true;
          btn.setAttribute('data-label', btn.textContent);
          btn.textContent = 'لحظة...';
        }
        fetch(form.action, { method: 'POST', body: new FormData(form), redirect: 'follow' })
          .then(function (res) {
            if (res.url && res.url.indexOf('customer_posted=true') !== -1) {
              showDone();
              return null;
            }
            return res.text();
          })
          .then(function (html) {
            if (html === null) return;
            if (html && html.indexOf('customer_posted=true') !== -1) {
              showDone();
              return;
            }
            classicSubmit();
          })
          .catch(function () {
            classicSubmit();
          })
          .then(function () {
            if (btn) {
              btn.disabled = false;
              if (btn.getAttribute('data-label')) btn.textContent = btn.getAttribute('data-label');
            }
          });
      });
    }

    if (readState().status === 'subscribed') return;

    if (
      window.location.search.indexOf('customer_posted=true') !== -1 &&
      window.location.hash === '#ss-pop-form'
    ) {
      showDone();
      open(true);
      return;
    }

    if (!eligible()) {
      if (tab) tab.classList.add('is-visible');
      return;
    }

    var timer = setTimeout(function () { open(false); }, delay);

    function cleanup() {
      clearTimeout(timer);
      window.removeEventListener('scroll', onScroll);
      document.removeEventListener('mouseout', onLeave);
    }
    function onScroll() {
      var h = document.body.scrollHeight - window.innerHeight;
      if (h > 0 && window.scrollY / h > 0.55) {
        open(false);
        cleanup();
      }
    }
    function onLeave(e) {
      if (e.clientY <= 0) {
        open(false);
        cleanup();
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('mouseout', onLeave);
  }

  function boot() {
    initReveal();
    initCounters();
    initPopup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
